// Content for the public FAQ page (/faq), from
// docs/SOALAN LAZIM (FAQ) AKHIRAT.CO.pdf. Malay copy is verbatim from the
// source document; English is the working translation.
// "{brand}" is replaced with the environment brand ("Ekubur.my" / "Akhirat.co")
// at render time — see utils/brand.ts.

export interface FaqEntry {
  question: string
  answer: string
}

export interface FaqItem {
  id: string
  en: FaqEntry
  ms: FaqEntry
}

export const faqItems: FaqItem[] = [
  {
    id: 'age-limit',
    en: {
      question: 'Is there an age limit to become a member?',
      answer:
        'There is no age limit. However, for applicants below the age of majority (under 18), consent and registration must be made together with a parent or guardian.',
    },
    ms: {
      question: 'Adakah terdapat had umur untuk menjadi ahli?',
      answer:
        'Tiada had umur. Walau bagaimanapun, bagi pemohon di bawah umur (bawah 18 tahun), persetujuan dan pendaftaran perlu dibuat bersama ibu bapa atau penjaga.',
    },
  },
  {
    id: 'register-family',
    en: {
      question: 'Can I register my family members as members?',
      answer:
        'Yes, you may register your family members as separate members under their own accounts.',
    },
    ms: {
      question: 'Bolehkah saya mendaftarkan ahli keluarga saya sebagai ahli?',
      answer:
        'Ya, anda boleh mendaftarkan ahli keluarga anda sebagai ahli terasing di bawah akaun mereka sendiri.',
    },
  },
  {
    id: 'verify-status',
    en: {
      question: 'How can I verify my membership status?',
      answer:
        'Status can be verified directly through the digital member card on the official website. Once registration and fee payment are completed, you will receive your physical member card delivered straight to your home via EasyParcel (physical/digital).',
    },
    ms: {
      question: 'Bagaimana saya boleh mengesahkan status keahlian saya?',
      answer:
        'Pengesahan status boleh dibuat terus melalui kad ahli digital di laman web rasmi. Selepas pendaftaran dan pembayaran yuran diselesaikan, anda akan menerima kad ahli fizikal melalui penghantaran terus ke rumah melalui EasyParcel (fizikal/digital).',
    },
  },
  {
    id: 'fee-changes',
    en: {
      question: 'Will the membership fee change from year to year?',
      answer:
        'No. The membership fee is a lifetime fee and is paid only once, upon registration.',
    },
    ms: {
      question: 'Adakah fi keahlian akan berubah dari tahun ke tahun?',
      answer:
        'Tidak. Yuran keahlian adalah seumur hidup (lifetime fee) dan hanya dibayar sekali semasa pendaftaran.',
    },
  },
  {
    id: 'cancel-or-withdraw',
    en: {
      question: 'Can I cancel my membership or withdraw my savings before the term ends?',
      answer:
        'Membership is for life, while insurance protection is renewed annually. If you wish to make a withdrawal from your savings account (such as a VA, Trust, or Wallet account) before death, you must submit a withdrawal application in accordance with the prescribed terms and procedures.',
    },
    ms: {
      question:
        'Bolehkah saya membatalkan keahlian atau mengeluarkan simpanan sebelum tamat tempoh?',
      answer:
        'Keahlian adalah seumur hidup, manakala perlindungan insurans diperbaharui secara tahunan. Sekiranya anda ingin membuat pengeluaran daripada akaun simpanan (seperti akaun VA, Trust, atau Wallet) sebelum kematian, anda perlu mengemukakan permohonan pengeluaran mengikut syarat dan prosedur yang ditetapkan.',
    },
  },
  {
    id: 'waiting-period',
    en: {
      question: 'Is there a waiting period before membership is fully active?',
      answer:
        'There is no waiting period. As soon as registration and payment are confirmed, membership and insurance protection become active automatically.',
    },
    ms: {
      question: 'Adakah terdapat tempoh menunggu sebelum keahlian aktif sepenuhnya?',
      answer:
        'Tiada tempoh menunggu. Sebaik sahaja pendaftaran dan bayaran disahkan, keahlian dan perlindungan insurans akan aktif secara automatik.',
    },
  },
  {
    id: 'children-covered',
    en: {
      question: 'Are a member’s children also covered by the insurance?',
      answer: 'No. Insurance protection is exclusive to registered members only.',
    },
    ms: {
      question: 'Adakah anak-anak ahli juga dilindungi oleh insurans?',
      answer: 'Tidak. Perlindungan insurans adalah khusus untuk ahli yang berdaftar sahaja.',
    },
  },
  {
    id: 'insurance-type',
    en: {
      question: 'What type of insurance protection comes with this membership?',
      answer:
        'Through the collaboration between Ahad Group Berhad and the foundation, members from registered organisations such as foundations receive the first year of insurance protection free of charge. Coverage includes death due to accident, permanent disability and funeral arrangements, renewed annually exclusively for members.',
    },
    ms: {
      question: 'Apakah jenis perlindungan insurans yang disertakan dengan keahlian ini?',
      answer:
        'Atas kerjasama Ahad Group Berhad bersama yayasan, bagi ahli dari organisasi yang berdaftar seperti Yayasan, untuk tahun pertama perlindungan insurans diberikan secara percuma. Perlindungan merangkumi kematian akibat kemalangan, hilang upaya kekal dan pengurusan jenazah yang diperbaharui secara tahunan khas untuk ahli.',
    },
  },
  {
    id: 'how-to-claim',
    en: {
      question: 'How do I make a claim when a death occurs?',
      answer:
        'A claim can be made online through the web portal or by contacting customer service, submitting the supporting documents (such as a copy of the identity card, the death certificate, next-of-kin details and the member card).',
    },
    ms: {
      question: 'Bagaimanakah cara untuk membuat tuntutan (claim) jika berlaku kematian?',
      answer:
        'Tuntutan boleh dibuat secara dalam talian melalui portal laman web atau dengan menghubungi khidmat pelanggan dengan menyerahkan dokumen sokongan (seperti salinan kad pengenalan, sijil kematian, maklumat waris serta kad ahli).',
    },
  },
  {
    id: 'beneficiary',
    en: {
      question: 'Can I register or update the beneficiary (penama) for my account?',
      answer:
        'Yes. Members are strongly encouraged to register a beneficiary on the website to ease the transfer of savings/benefits to their heirs later.',
    },
    ms: {
      question: 'Bolehkah saya mendaftarkan atau mengemas kini penama (beneficiary) bagi akaun saya?',
      answer:
        'Ya, ahli sangat digalakkan mendaftarkan penama di laman web bagi memudahkan urusan penyerahan simpanan/manfaat kepada waris kelak.',
    },
  },
  {
    id: 'check-balance',
    en: {
      question: 'How do I check my savings balance (VA acc / Trust / Wallet)?',
      answer:
        'Your savings balance and account statements can be checked at any time by logging into the member portal account on the official website.',
    },
    ms: {
      question: 'Bagaimanakah cara untuk menyemak baki simpanan (VA acc / Trust / Wallet)?',
      answer:
        'Baki simpanan dan penyata akaun boleh disemak pada bila-bila masa dengan log masuk ke dalam akaun portal ahli di laman web rasmi.',
    },
  },
  {
    id: 'payment-methods',
    en: {
      question: 'What payment methods are accepted for the membership fee?',
      answer: 'Payment can be made online via internet banking (FPX) only.',
    },
    ms: {
      question: 'Apakah kaedah pembayaran yang diterima untuk yuran keahlian?',
      answer: 'Pembayaran boleh dibuat secara dalam talian melalui perbankan internet (FPX) sahaja.',
    },
  },
  {
    id: 'lost-card',
    en: {
      question: 'What if I lose my member card or want to update my personal details?',
      answer:
        'Updates to your phone number and address, and card replacement requests, can be made directly through your account profile on the website.',
    },
    ms: {
      question: 'Bagaimana jika saya kehilangan kad ahli atau ingin mengemaskini maklumat peribadi?',
      answer:
        'Kemaskini nombor telefon, alamat, dan permohonan penggantian kad boleh dilakukan terus melalui profil akaun di laman web.',
    },
  },
  {
    id: 'become-provider',
    en: {
      question: 'Can I become a service provider (provider) or volunteer on {brand}?',
      answer: 'Yes, you may. Registration as a service provider (provider) is permitted.',
    },
    ms: {
      question: 'Bolehkah saya menjadi penyedia perkhidmatan (provider) atau sukarelawan di {brand}?',
      answer: 'Ya, boleh. Pendaftaran sebagai penyedia perkhidmatan (provider) adalah dibenarkan.',
    },
  },
  {
    id: 'infaq-and-shop',
    en: {
      question: 'Can I make infaq, give sedekah, or shop on this platform?',
      answer:
        'Yes. The platform is also equipped with e-commerce features to make it easy for you to make infaq and sedekah, as well as to purchase goods/services.',
    },
    ms: {
      question: 'Bolehkah saya membuat infaq, sedekah, atau membeli-belah di platform ini?',
      answer:
        'Ya, boleh. Platform ini turut dilengkapi fungsi e-dagang (e-commerce) untuk memudahkan anda membuat infaq, sedekah, serta pembelian barangan/perkhidmatan.',
    },
  },
  {
    id: '24-hour',
    en: {
      question: 'Is this protection in effect 24 hours a day?',
      answer:
        'Yes. Protection covers 24 hours a day as soon as your registration is successfully confirmed.',
    },
    ms: {
      question: 'Adakah perlindungan ini berkuat kuasa 24 jam?',
      answer: 'Ya. Perlindungan merangkumi 24 jam sehari sebaik sahaja pendaftaran anda berjaya disahkan.',
    },
  },
  {
    id: 'non-malaysians',
    en: {
      question: 'Is registration open to non-Malaysian citizens?',
      answer:
        'For now, registration is open to Malaysian and Singaporean citizens only.',
    },
    ms: {
      question: 'Adakah pendaftaran terbuka kepada bukan warganegara Malaysia?',
      answer: 'Buat masa ini, pendaftaran hanya terbuka kepada warganegara Malaysia dan Singapura sahaja.',
    },
  },
]

// Contact details from the source document, shared by both languages.
export const faqContact = {
  email: 'support@akhirat.co',
  phoneDisplay: '011-3774 6025 (Puan Ainna)',
  whatsapp: 'https://wa.me/601137746025',
}
